import React from "react";
import { useNavigate } from "react-router-dom";
import { theme } from "../theme";

const getInitials = (name = "", surname = "") => {
  const initials = `${name?.[0] || ""}${surname?.[0] || ""}`.toUpperCase();
  return initials || "?";
};

const rowStyle = { display: "flex", justifyContent: "space-between", gap: 12 };

const ClientDossierCard = ({ client }) => {
  const navigate = useNavigate();
  const fullName = client ? `${client.name || ""} ${client.surname || ""}`.trim() : "—";

  return (
    <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 14 }}>
      <div style={{ padding: "16px 18px 14px", borderBottom: "1px solid #eeeef2" }}>
        <h2 style={{ margin: 0, fontSize: 15.5, fontWeight: 650, letterSpacing: "-0.2px" }}>Buyer</h2>
      </div>
      <div style={{ padding: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 13 }}>
          <div
            style={{
              width: 44,
              height: 44,
              borderRadius: 12,
              background: theme.text,
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 15,
              fontWeight: 600,
              flex: "none",
            }}
          >
            {getInitials(client?.name, client?.surname)}
          </div>
          <div style={{ minWidth: 0, flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 650 }}>{fullName}</div>
            <div style={{ fontSize: 12.5, color: theme.textMuted, marginTop: 2 }}>
              Primary signatory{client?.buyer_type_display ? ` · ${client.buyer_type_display}` : ""}
            </div>
          </div>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 7, marginTop: 14, fontSize: 13.5 }}>
          {client?.email && (
            <div style={rowStyle}>
              <span style={{ color: theme.textMuted }}>Email</span>
              <a
                href={`mailto:${client.email}`}
                style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", color: theme.accent }}
              >
                {client.email}
              </a>
            </div>
          )}
          {client?.phone && (
            <div style={rowStyle}>
              <span style={{ color: theme.textMuted }}>Phone</span>
              <span style={{ fontWeight: 500 }}>{client.phone}</span>
            </div>
          )}
          {client?.other_contracts_count > 0 && (
            <div style={rowStyle}>
              <span style={{ color: theme.textMuted }}>Other contracts</span>
              <a href={`/client-details/${client.id}`} style={{ color: theme.accent }}>
                {client.other_contracts_count} more
              </a>
            </div>
          )}
        </div>

        <button
          type="button"
          onClick={() => client?.id && navigate(`/client-details/${client.id}`)}
          disabled={!client?.id}
          style={{
            display: "block",
            width: "100%",
            textAlign: "center",
            marginTop: 14,
            fontSize: 13,
            fontWeight: 600,
            padding: 9,
            border: `1px solid ${theme.border}`,
            borderRadius: 9,
            color: theme.text,
            background: theme.surface,
            cursor: "pointer",
          }}
        >
          Open client page
        </button>
      </div>
    </div>
  );
};

export default ClientDossierCard;
